import { create } from "@bufbuild/protobuf";
import { DownloadSimpleIcon } from "@phosphor-icons/react";

import Button, { ButtonVariant } from "@gx/dls/buttons/Button";
import { GetPresignedDownloadUriRequestSchema } from "@gx/ts-contracts/services/source/api/source_pb";

import { useGetPresignedDownloadUriMutation } from "@/api/mutations/file-download";

import { useDownloadFile } from "@/hooks/useDownloadFile";

interface FileDownloadProps {
  objectStorageUri: string;
  filename: string;
}

const FileDownload = ({ objectStorageUri, filename }: FileDownloadProps) => {
  const { mutateAsync: getPresignedDownloadUri, isPending } = useGetPresignedDownloadUriMutation();

  const handleDownload = useDownloadFile({
    getUrl: async () => {
      const result = await getPresignedDownloadUri(
        create(GetPresignedDownloadUriRequestSchema, {
          objectStorageUri,
        }),
      );
      return result?.downloadUri ?? "";
    },
    filename,
  });

  return (
    <Button
      variant={ButtonVariant.TERTIARY}
      icon={DownloadSimpleIcon}
      onClick={(e) => {
        e.stopPropagation();
        void handleDownload();
      }}
      isDisabled={isPending}
    />
  );
};

export default FileDownload;
